import React from "react";
import InfoIcon from "@material-ui/icons/Info";

export const AlertBox = ({ children, style }) => {
  return (
    <div
      style={{
        backgroundColor: "#42474c",
        padding: "8px",
        display: "flex",
        alignItems: "center",
        borderRadius: "8px",
        fontSize: "0.8rem",
        ...style,
      }}
    >
      <span
        id="client-snackbar"
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <InfoIcon style={{ fontSize: 20, marginRight: 8 }} />
        {children}
      </span>
    </div>
  );
};
